import { call, put, all, takeLatest, select } from 'redux-saga/effects';
import { RequerimentoService } from '@services/requerimento';
import {
  DadosPessoaisService,
  AlteracaoPerfilService,
  PatrocinadoraService,
  MemoriaCalculoParticipanteService,
} from '@services';
import { intervalToDuration, format, parse } from 'date-fns';
import { toast } from 'react-toastify';
import { nomeSobrenome } from '@utils';
import {
  deslogaUsuarioSuccess,
  logaUsuarioSuccess,
  requestError,
  formularioEnviado,
  atualizaStateRequest,
  gerarProtocoloSuccess,
  atualizaFormRascunho,
  dadosPessoaisSuccess,
  addCnpbAndPlanName,
  obterPaginasDisponiveisExtratoSuccess,
  obterPaginasDisponiveisExtratoRequest,
  obterPendenciasUsuarioSuccess,
  obterPendenciasUsuarioRequest,
} from './actions';
import { alterarCorSistemaRequest } from '../personalizacaoCor/actions';
import { APIAutenticacao } from '../../../common/services/autenticacao';
import { limpaExtrato } from '../extratoContribuicao/actions';
import { recuperaPersonalizacaoRequest } from '../personalizacaoHome/actions';
import { PlanoParticipanteService } from '../../../common/services/planoParticipante';
import {
  ADD_DRAFT_ITEM,
  ALTERAR_PLANO_USUARIO_REQUEST,
  ATUALIZAR_DADOS_CADASTRAIS_REQUEST,
  CREATE_DRAFT_REQUEST,
  DELETE_DRAFT_ITEM,
  FALE_CONOSCO_REQUEST,
  FINISH_FORM,
  FORM_REQUEST,
  GERAR_PROTOCOLO_REQUEST,
  OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST,
  OBTER_PENDENCIAS_USUARIO_REQUEST,
  REQUEST_SOLICITACAO_DE_EMPRESTIMO,
  UPDATE_ATTACHMENT_REQUEST,
  UPDATE_DRAFT_ITEM,
  USER_AUTH_REQUEST,
  USER_AUTHADM_REQUEST,
  USER_DATA_REQUEST,
  USER_LOGOUT_REQUEST,
} from './constants';
import {
  obterTelasDisponiveisRequest,
  resetaTelasDisponiveisRequest,
} from '../telasDisponiveis/actions';
import {
  obterLimiteEmprestimoRequest,
  resetEmprestimos,
} from '../emprestimo/actions';
import { ConfiguracaoPortalService } from '../../../common/services/configuracaoPortal';
import { resetBoasVindas } from '../boasVindas/actions';
import { insereFaleConosco } from '../../../common/services/fale-conosco';
import { hideLoad, showLoad } from '../loading/actions';
import { resetRequerimentos } from '../requerimento/actions';
import { resetaOpcoesTelaRenda } from '../simulacaoBeneficio/actions';
import { obterMenuAtendimentoVirtualRequest } from '../atendimentoVirtual/actions';

const getTodosPlanosParticipante = (data) => {
  if (data.PLANO_PREVIDENCIA.length > 0) {
    const planos = data.PLANO_PREVIDENCIA[0]
      .map((element) => ({
        value: element.IdCardeal.toString(),
        label: element.descricao,
        sitpart: element.SitPart,
        tipoBeneficio: element.TipoBeneficio,
      }))
      .sort((a, b) => a.value - b.value);
    return planos;
  }

  return [
    {
      value: '0',
      label: 'Matrícula de Teste',
      sitpart: '0',
      tipoBeneficio: '0',
    },
  ];
};

const dadosPessoaisNaoFormatadosSemArray = (dadosPessoaisNaoFormatados) => {
  return {
    matricula: dadosPessoaisNaoFormatados.PERNR[0],
    nome: dadosPessoaisNaoFormatados.CNAME[0],
    matriculaFalecido: dadosPessoaisNaoFormatados.MATRICULA_FALECIDO[0],
    dependente: dadosPessoaisNaoFormatados.NR_PENS_DEPENDENTE[0],
    cep: dadosPessoaisNaoFormatados.CEP[0],
    endereco: dadosPessoaisNaoFormatados.ENDERECO[0],
    numero: dadosPessoaisNaoFormatados.NUMERO[0],
    complemento: dadosPessoaisNaoFormatados.COMPLEMENTO[0],
    bairro: dadosPessoaisNaoFormatados.BAIRRO[0],
    cidade: dadosPessoaisNaoFormatados.CIDADE[0],
    estado: dadosPessoaisNaoFormatados.ESTADO[0],
    telefoneFixo: dadosPessoaisNaoFormatados.TELEFONE_FIXO[0],
    celular: dadosPessoaisNaoFormatados.CELULAR[0],
    email: dadosPessoaisNaoFormatados.EMAIL[0],
    dtNascimento: dadosPessoaisNaoFormatados.DAT_NASC[0],
    sexo: dadosPessoaisNaoFormatados.SEXO[0],
    mae: dadosPessoaisNaoFormatados.MAE[0],
    pai: dadosPessoaisNaoFormatados.PAI[0],
    conjuge: dadosPessoaisNaoFormatados.CONJUGE[0],
    cpf: dadosPessoaisNaoFormatados.CPF[0],
    rg: dadosPessoaisNaoFormatados.RG[0],
    orgEmissor: dadosPessoaisNaoFormatados.ORG_EMISSOR[0],
    uf: dadosPessoaisNaoFormatados.UF[0],
    dtEmissao: dadosPessoaisNaoFormatados.DAT_EMISSAO[0],
    localNascimento: dadosPessoaisNaoFormatados.LOC_NACIMENTO[0],
    estadoNasc: dadosPessoaisNaoFormatados.ESTADO_NASC[0],
    pais: dadosPessoaisNaoFormatados.PAIS[0],
    nacionalidade: dadosPessoaisNaoFormatados.NACIONALIDADE[0],
    estadoCivil: dadosPessoaisNaoFormatados.ESTADO_CIVIL[0],
    numBanco: dadosPessoaisNaoFormatados.NUM_BANCO[0],
    agencia: dadosPessoaisNaoFormatados.AGENCIA[0],
    conta: dadosPessoaisNaoFormatados.CONTA[0],
    status: dadosPessoaisNaoFormatados.STATUS[0],
    dtAdminissao: dadosPessoaisNaoFormatados.DATA_ADMISSAO[0],
    dtDesligamento: dadosPessoaisNaoFormatados.DATA_DESLIGAMENTO[0],
    motivoDeslig: dadosPessoaisNaoFormatados.MOTIVO_DESLIG[0],
    dtAfastamento: dadosPessoaisNaoFormatados.DATA_AFASTAMENTO[0],
    motivoEncerramento: dadosPessoaisNaoFormatados.MOTIVO_AFASTAMENTO[0],
    tpBeneficio: dadosPessoaisNaoFormatados.TIPO_BENEFICIO[0],
    dtEncerramentoBeneficio: dadosPessoaisNaoFormatados.DT_ENCE_BENEFICIO[0],
    motivoAfastamento: dadosPessoaisNaoFormatados.MOT_ENCERRAMENTO[0],
    planoPrevidencia: dadosPessoaisNaoFormatados.PLANO_PREVIDENCIA[0],
    situacaoParticipante: dadosPessoaisNaoFormatados.SIT_PART_PLANO[0],
  };
};

function dadosPessoaisSAP({ dadosPessoaisNaoFormatados, matricula }) {
  const idade = intervalToDuration({
    start: new Date(),
    end: new Date(dadosPessoaisNaoFormatados.DAT_NASC[0]),
  }).years;

  const nascimento = format(
    new Date(dadosPessoaisNaoFormatados.DAT_NASC[0].replace(/-/g, '/')),
    'dd/MM/yyyy'
  );

  const dataExpedicaoRg =
    dadosPessoaisNaoFormatados.DAT_EMISSAO[0] === '0000-00-00'
      ? '01/01/9999'
      : format(
          new Date(
            dadosPessoaisNaoFormatados.DAT_EMISSAO[0].replace(/-/g, '/')
          ),
          'dd/MM/yyyy'
        );

  const formataNumCelular = () => {
    let formatNumCelular = dadosPessoaisNaoFormatados.CELULAR[0].replace(
      '-',
      ''
    );
    if (formatNumCelular[0] === '0')
      formatNumCelular = formatNumCelular.replace(formatNumCelular[0], '');
    return formatNumCelular;
  };

  const contaBancaria = dadosPessoaisNaoFormatados.CONTA[0].split('-');
  const dadosBanco = dadosPessoaisNaoFormatados.NUM_BANCO[0].split('-');

  const dadosPessoaisFormatados = {
    id: matricula,
    nome: dadosPessoaisNaoFormatados.CNAME[0],
    nascimento,
    nacionalidade: dadosPessoaisNaoFormatados.NACIONALIDADE[0],
    genero: dadosPessoaisNaoFormatados.SEXO[0],
    estadoCivil: dadosPessoaisNaoFormatados.ESTADO_CIVIL[0],
    pai: dadosPessoaisNaoFormatados.PAI[0],
    mae: dadosPessoaisNaoFormatados.MAE[0],
    cpf: dadosPessoaisNaoFormatados.CPF[0],
    rg: dadosPessoaisNaoFormatados.RG[0],
    pis: '',
    idade,
    maiorIdade: idade >= 18,
    dataAdmissao: dadosPessoaisNaoFormatados.DATA_ADMISSAO[0],
    orgaoEmissorRg: dadosPessoaisNaoFormatados.ORG_EMISSOR[0],
    dataExpedicaoRg,
    ufExpedicaoRg: dadosPessoaisNaoFormatados.UF[0],
    profissao: '',
    exposta: '',
    salario: '',
    email: dadosPessoaisNaoFormatados.EMAIL[0],
    celular: formataNumCelular(),
    telefone: dadosPessoaisNaoFormatados.TELEFONE_FIXO[0],
    logradouro: dadosPessoaisNaoFormatados.ENDERECO[0],
    numero: dadosPessoaisNaoFormatados.NUMERO[0],
    complemento: dadosPessoaisNaoFormatados.COMPLEMENTO[0],
    bairro: dadosPessoaisNaoFormatados.BAIRRO[0],
    cidade: dadosPessoaisNaoFormatados.CIDADE[0],
    cep: dadosPessoaisNaoFormatados.CEP[0],
    estado: dadosPessoaisNaoFormatados.ESTADO[0],
    conta: parseInt(contaBancaria[0], 10),
    digitoConta: contaBancaria[1],
    agencia: parseInt(dadosPessoaisNaoFormatados.AGENCIA[0], 10),
    codBanco: dadosBanco[0].trim(),
  };

  return dadosPessoaisFormatados;
}

function* validaLogin({ values }) {
  const response = yield call(
    APIAutenticacao.validaLogin,
    values.matricula,
    values.senha
  );

  if (response.toString().includes('Erro')) {
    yield put(requestError(response));
  } else if (response === false) {
    const retornoValidacao = {
      matricula: '',
      remember: values.remember,
      token: '',
      autenticado: false,
      plano: '',
      nomeParticipante: '',
    };

    yield put(logaUsuarioSuccess(retornoValidacao));
    yield put(requestError(false));
  } else {
    const rememberLS = localStorage.getItem('LembrarMatricula');
    localStorage.setItem('nivelsessao', response.nivelsessao);

    if (values.remember === true) {
      if (rememberLS === null) {
        localStorage.setItem('LembrarMatricula', response.matricula);
      } else {
        localStorage.removeItem('LembrarMatricula');
        localStorage.setItem('LembrarMatricula', response.matricula);
      }
    } else if (rememberLS !== null) {
      localStorage.removeItem('LembrarMatricula');
    }

    yield put(
      atualizaStateRequest({
        matricula: response.matricula,
        token: response.token,
        nivelsessao: response.nivelsessao,
      })
    );
  }
}

function* validaLoginADM({ values }) {
  const response = yield call(
    APIAutenticacao.validaLoginADM,
    values.token,
    values.matricula
  );
  localStorage.setItem('nivelsessao', response.nivelsessao);
  yield put(
    atualizaStateRequest({
      matricula: response.matricula,
      token: response.token,
      nivelsessao: response.nivelsessao,
    })
  );
}

function* obterPendenciasUsuario({ values }) {
  const confPortalService = new ConfiguracaoPortalService();
  const pendenciasUsuario = yield confPortalService.VerificarPendenciasUsuario(
    values.matricula,
    values.token
  );
  yield put(obterPendenciasUsuarioSuccess(pendenciasUsuario));
}

function* mantemDados({ values }) {
  if (values.id) if (values.id !== values.matricula) yield put(showLoad());

  yield put(resetEmprestimos());

  const perfilParticipanteService = new AlteracaoPerfilService();
  const confPortalService = new ConfiguracaoPortalService();
  const dadosPessoaisService = new DadosPessoaisService();
  const patrocinadoraService = new PatrocinadoraService();
  const memoriaCalculoParticipanteService =
    new MemoriaCalculoParticipanteService();
  const { data: dadosPessoaisNaoFormatados } =
    yield dadosPessoaisService.getDadosPessoaisSAP(
      values.matricula,
      values.token
    );

  const listaPlanosParticipante = getTodosPlanosParticipante(
    dadosPessoaisNaoFormatados
  );

  const perfilParticipante =
    yield perfilParticipanteService.getPerfilAtualParticipante(
      values.matricula
    );

  const patrocinadora = yield patrocinadoraService.getPatrocinadoraParticipante(
    values.matricula
  );

  const corteExtrato = yield confPortalService.getConfiguracaoesPortal(
    'Data Corte - Extrato'
  );

  const corteContracheque = yield confPortalService.getConfiguracaoesPortal(
    'Data Corte - Contracheque'
  );

  const DIB =
    yield memoriaCalculoParticipanteService.getMemoriaCalculoBeneficioParticipante(
      values.matricula,
      values.plano || listaPlanosParticipante[0].value
    );

  const mesesCorte = corteExtrato.data.results[0].Valor.split('/');
  const mesesCorteContracheque =
    corteContracheque.data.results[0].Valor.split('/');
  const dataDIB =
    DIB.data.ObterMemoriaCalculoBeneficioParticipanteResult.DIB || '01/11/1997';

  const retornoValidacao = {
    matricula: values.matricula,
    token: values.token,
    nivelsessao: localStorage.getItem('nivelsessao'),
    autenticado: true,
    erro: false,
    patrocinadora: patrocinadora?.NomePatrocinadora,
    plano: values.plano || listaPlanosParticipante[0].value,
    perfil: perfilParticipante,
    status: dadosPessoaisNaoFormatados.STATUS[0],
    listaPlanos: listaPlanosParticipante,
    nomeParticipante: nomeSobrenome(dadosPessoaisNaoFormatados.CNAME[0]),
    corteExtrato: mesesCorte,
    corteContracheque: mesesCorteContracheque,
    DIB: dataDIB,
  };

  yield put(logaUsuarioSuccess(retornoValidacao));

  yield put(
    obterPendenciasUsuarioRequest({
      matricula: values.matricula,
      token: values.token,
    })
  );

  const dadosPessoaisFormatados = dadosPessoaisSAP({
    dadosPessoaisNaoFormatados,
    matricula: values.matricula,
  });

  const dadosPessoaisParticipante = {
    dadosPessoaisFormatados,
    dadosPessoaisNaoFormatados: dadosPessoaisNaoFormatadosSemArray(
      dadosPessoaisNaoFormatados
    ),
  };

  yield put(dadosPessoaisSuccess(dadosPessoaisParticipante));
  yield put(obterTelasDisponiveisRequest());
  yield put(obterMenuAtendimentoVirtualRequest());

  if (values.id === values.matricula) {
    yield put(
      alterarCorSistemaRequest({
        matricula: values.id,
        plano: values.plano || listaPlanosParticipante[0].value,
      })
    );
  }

  yield put(obterPaginasDisponiveisExtratoRequest());
  yield put(obterLimiteEmprestimoRequest());

  if (values.id) if (values.id !== values.matricula) yield put(hideLoad());
}

function* atualizaDadosUsuario({ values, openModalError }) {
  const dadosPessoaisService = new DadosPessoaisService();
  const { matricula, token, nivelsessao } = yield select((state) => state.user);
  const { dadosSAPNaoTratados } = yield select((state) => state.user);

  try {
    const response = yield dadosPessoaisService.atualizarSAPDadosPessoais({
      ...values,
      token,
      matricula,
      planoPrevidencia: '',
      dtNascimento: dadosSAPNaoTratados.dtNascimento,
    });
    if (response.data.Status === 'Erro') {
      openModalError(true);
    } else {
      yield put(
        atualizaStateRequest({
          matricula,
          token,
          nivelsessao,
        })
      );
      openModalError(false);
    }
  } catch {
    openModalError(true);
  }
}

function* logoutUsuario() {
  const { id, token } = yield select((state) => state.user);

  yield put(limpaExtrato());
  yield put(resetBoasVindas());
  yield put(deslogaUsuarioSuccess());
  yield put(resetRequerimentos());
  yield put(resetEmprestimos());
  yield put(resetaOpcoesTelaRenda());
  yield put(resetaTelasDisponiveisRequest());

  if (id && token) yield APIAutenticacao.desativaSessao(id, token);
}

function* gerarProtocolo() {
  const service = new RequerimentoService();
  const users = yield select((state) => state.user);

  const protocoloResponse = yield service.gerarProtocoloAtendimento(
    users.matricula,
    users.token
  );

  const { protocolo } = protocoloResponse.data[0];

  yield put(gerarProtocoloSuccess({ protocolo }));

  return protocolo;
}

function separaCamposAnexos(campos) {
  const camposSemAnexo = Object.keys(campos)
    .filter((k) => campos[k] !== '' && !k.includes('anexo'))
    .reduce((a, k) => ({ ...a, [k]: campos[k] }), {});
  const camposAnexosPrenchidos = Object.keys(campos)
    .filter((k) => k.includes('anexo') && !!campos[k])
    .reduce((a, k) => [...a, { name: k, file: campos[k] }], []);

  return { camposSemAnexo, camposAnexosPrenchidos };
}

function* enviaAnexos(anexos, isEmprestimo = false) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const protocolo = yield select((state) => state.user.protocolo);

  if (isEmprestimo) {
    yield anexos.forEach((anexo) => {
      service.persistirAnexo({
        anexo,
        protocolo,
        matricula: user.matricula,
        token: user.token,
        nomearquivo: anexo.name,
        tipoanexo: 'Emprestimo',
      });
    });
  } else {
    yield anexos.forEach((anexo) => {
      const convertedFileList = [...anexo.file];

      convertedFileList.forEach((file) => {
        service.persistirAnexo({
          anexo: file,
          protocolo,
          matricula: user.matricula,
          token: user.token,
          nomearquivo: file.name,
          tipoanexo: anexo.name.replace('anexo', ''),
        });
      });
    });
  }
}

function* concluirEnvioForm({ formulario }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const protocolo = yield select((state) => state.user.protocolo);
  const dadosAtualizados = yield select(
    (state) => state.requerimento.dadosPessoaisRequerimento
  );
  const dadosSAP = yield select((state) => state.user.dadosSAPNaoTratados);

  const dadoscadastrais = {
    email: dadosAtualizados.email,
    celular: dadosAtualizados.celular,
    telefoneFixo: dadosAtualizados.telefoneFixo,

    nome: dadosSAP.nome,
    dtNascimento: dadosAtualizados.dtNascimento,
    nacionalidade: dadosAtualizados.nacionalidade,
    sexo: dadosAtualizados.sexo,
    estadoCivil: dadosAtualizados.estadoCivil,
    pai: dadosAtualizados.pai,
    mae: dadosAtualizados.mae,

    rg: dadosAtualizados.rg,
    orgEmissor: dadosAtualizados.orgEmissor,
    uf: dadosAtualizados.uf,
    cpf: dadosSAP.cpf,
    dtEmissao: dadosAtualizados.dtEmissao,

    endereco: dadosAtualizados.endereco,
    numero: dadosAtualizados.numero,
    complemento: dadosAtualizados.complemento,
    cep: dadosAtualizados.cep,
    bairro: dadosAtualizados.bairro,
    cidade: dadosAtualizados.cidade,
    estado: dadosAtualizados.estado,

    banco: dadosAtualizados.banco,
    agencia: dadosAtualizados.agencia,
    conta: dadosAtualizados.conta,
    digito: dadosAtualizados.digito,
  };

  const allAttachments = user.formularioLista.reduce((prev, curr) => {
    return [...prev, ...curr.anexos];
  }, []);

  yield enviaAnexos(allAttachments);

  yield service.concluirRequerimento({
    token: user.token,
    matricula: user.matricula,
    formulario,
    protocolo,
    dadoscadastrais,
  });
}

function* adicionaItemRascunho({ campos, successMessage }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const protocolo = yield select((state) => state.user.protocolo);
  const listaAntiga = yield select((state) => state.user.formularioLista);

  const { camposSemAnexo, camposAnexosPrenchidos } = separaCamposAnexos(campos);

  const responseForm = yield service.atualizaRequerimento({
    matricula: user.matricula,
    token: user.token,
    campos: [...listaAntiga, camposSemAnexo],
    protocolo,
  });

  if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
    yield put(
      atualizaFormRascunho([
        ...listaAntiga,
        { ...camposSemAnexo, anexos: camposAnexosPrenchidos },
      ])
    );
    toast.success(successMessage);
  } else {
    toast.error('Oops... Algo deu errado');
  }
}

function* atualizaItemRascunho({ campos, camposAntigos, successMessage }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const protocolo = yield select((state) => state.user.protocolo);

  const { camposSemAnexo, camposAnexosPrenchidos } = separaCamposAnexos(campos);

  const listaAntiga = yield select((state) => state.user.formularioLista);

  const newListWithItemUpdated = listaAntiga.map((item) => {
    if (camposAntigos.cpf === item.cpf) {
      return { ...camposSemAnexo, anexos: camposAnexosPrenchidos };
    }
    return item;
  });

  const responseForm = yield service.atualizaRequerimento({
    matricula: user.matricula,
    token: user.token,
    campos: newListWithItemUpdated,
    protocolo,
  });

  if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
    yield put(atualizaFormRascunho([...newListWithItemUpdated]));
    toast.success(successMessage);
  } else {
    toast.error('Oops... Algo deu errado');
  }
}

function* excluiItemRascunho({ campos }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const protocolo = yield select((state) => state.user.protocolo);
  const listaAntiga = yield select((state) => state.user.formularioLista);

  const newListWithItemExcluded = listaAntiga.filter((item) => {
    return campos.cpf !== item.cpf;
  });

  const responseForm = yield service.atualizaRequerimento({
    matricula: user.matricula,
    token: user.token,
    campos: newListWithItemExcluded,
    protocolo,
  });

  if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
    yield put(atualizaFormRascunho([...newListWithItemExcluded]));
  }
}

function* criaFormRascunho({ formulario }) {
  const protocolo = yield gerarProtocolo();
  const user = yield select((state) => state.user);

  const service = new RequerimentoService();
  const initialList = [];

  const responseForm = yield service.persistirFormulario(
    user.matricula,
    user.token,
    initialList,
    formulario,
    protocolo
  );

  if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
    yield put(atualizaFormRascunho(initialList));
  }
}

function* enviaForm({ campos, formulario, navigate, salvar }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);

  const { camposSemAnexo, camposAnexosPrenchidos } = separaCamposAnexos(campos);

  try {
    const protocolo = yield gerarProtocolo();
    const responseForm = yield service.persistirFormulario(
      user.matricula,
      user.token,
      camposSemAnexo,
      formulario,
      protocolo
    );

    if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
      yield enviaAnexos(camposAnexosPrenchidos);
      yield concluirEnvioForm({ formulario });

      if (navigate) {
        navigate('/requerimentos/andamento/*');
      }

      if (salvar) {
        const date = parse(
          responseForm.data[0].data,
          'yyyy-MM-dd HH:mm:ss',
          new Date()
        );

        const formattedDate = format(date, 'dd/MM/yyyy HH:mm:ss');

        yield put(
          formularioEnviado({
            formulario,
            protocolo,
            dataHora: formattedDate,
          })
        );
      }

      toast.success(
        `Requerimento enviado com sucesso! O número do seu protocolo é:${protocolo}`
      );
    }
  } catch (e) {
    toast.error(
      'Erro ao enviar requerimento. Favor re-logar e tentar novamente.'
    );
  }
}

function* enviaSimulacaoEmprestimo({ campos, anexos }) {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);

  const { camposSemAnexo } = separaCamposAnexos(campos);

  const formulario = 'SimulacaoEmprestimo';

  try {
    const protocolo = yield gerarProtocolo();
    const responseForm = yield service.persistirFormulario(
      user.matricula,
      user.token,
      camposSemAnexo,
      formulario,
      protocolo
    );

    if (responseForm.status === 200 && !!responseForm.data[0].linhasafetadas) {
      yield enviaAnexos(anexos, true);
      yield concluirEnvioForm({ formulario });

      toast.success('Solicitação de empréstimo enviada com sucesso!');
    }
  } catch (e) {
    toast.error('Erro ao enviar solicitação de empréstimo.');
  }
}

function* alterarPlanoOuUsuario({ values }) {
  localStorage.setItem('Plano', values.plano);

  yield put(
    atualizaStateRequest({
      id: values.id,
      matricula: values.matricula,
      token: values.token,
      plano: values.plano,
    })
  );

  yield put(
    recuperaPersonalizacaoRequest({
      matricula: values.matricula,
      plano: values.plano,
    })
  );
}

function* enviaAnexoComplementar({ protocolo, anexo }) {
  yield put(gerarProtocoloSuccess({ protocolo }));

  const { camposAnexosPrenchidos } = separaCamposAnexos(anexo);

  yield enviaAnexos(camposAnexosPrenchidos);

  toast.success('Anexo(s) enviados com sucesso.');
}

function* obterPaginasDisponiveis() {
  try {
    const service = new PlanoParticipanteService();
    const user = yield select((state) => state.user);

    const response = yield service.obterPaginasPorPlano(
      user.plano,
      user.status
    );

    const pages = response?.data?.Links || [];
    yield put(obterPaginasDisponiveisExtratoSuccess(pages));

    const dadosPlano = response?.data?.DadosPlano || { Plano: '', CNPB: '' };
    yield put(
      addCnpbAndPlanName({ plano: dadosPlano.Plano, cnpb: dadosPlano.CNPB })
    );
  } catch (e) {
    console.error('Erro ao obter páginas por plano:', e);
  }
}

function* enviaFaleConosco({ payload }) {
  const user = yield select((state) => state.user);
  try {
    const {
      assunto,
      celular,
      eMail,
      matricula,
      mensagem,
      nome,
      telefone,
      anexoFaleConosco,
    } = payload;

    const protocolo = anexoFaleConosco ? yield gerarProtocolo() : '';

    const { camposAnexosPrenchidos } = separaCamposAnexos(payload);

    if (anexoFaleConosco) {
      yield enviaAnexos(camposAnexosPrenchidos);
    }

    const response = yield insereFaleConosco({
      Assunto: assunto,
      Celular: celular,
      Email: eMail,
      Matricula: matricula,
      Mensagem: mensagem,
      Nome: nome,
      Telefone: telefone,
      Protocolo: protocolo,
      token: user.token,
    });

    if (response.data[0].linhasafetadas > 0) {
      yield toast.success('Enviado com sucesso.');
    } else {
      throw new Error('Erro ao enviar fale conosco');
    }
  } catch (e) {
    toast.error('Erro no envio do fale conosco.');
  }
}

export default all([
  takeLatest(USER_AUTH_REQUEST, validaLogin),
  takeLatest(USER_AUTHADM_REQUEST, validaLoginADM),
  takeLatest(USER_LOGOUT_REQUEST, logoutUsuario),
  takeLatest(FORM_REQUEST, enviaForm),
  takeLatest(USER_DATA_REQUEST, mantemDados),
  takeLatest(ALTERAR_PLANO_USUARIO_REQUEST, alterarPlanoOuUsuario),
  takeLatest(GERAR_PROTOCOLO_REQUEST, gerarProtocolo),
  takeLatest(CREATE_DRAFT_REQUEST, criaFormRascunho),
  takeLatest(ADD_DRAFT_ITEM, adicionaItemRascunho),
  takeLatest(UPDATE_DRAFT_ITEM, atualizaItemRascunho),
  takeLatest(DELETE_DRAFT_ITEM, excluiItemRascunho),
  takeLatest(FINISH_FORM, concluirEnvioForm),
  takeLatest(UPDATE_ATTACHMENT_REQUEST, enviaAnexoComplementar),
  takeLatest(REQUEST_SOLICITACAO_DE_EMPRESTIMO, enviaSimulacaoEmprestimo),
  takeLatest(
    OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST,
    obterPaginasDisponiveis
  ),
  takeLatest(ATUALIZAR_DADOS_CADASTRAIS_REQUEST, atualizaDadosUsuario),
  takeLatest(FALE_CONOSCO_REQUEST, enviaFaleConosco),
  takeLatest(OBTER_PENDENCIAS_USUARIO_REQUEST, obterPendenciasUsuario),
]);
